export default "__VITE_ASSET__DqThkKBJ__"